var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"editor_top"}},[_c('div',{staticClass:"editor_top",on:{"click":_vm.toHome}},[_c('img',{attrs:{"src":require("@/assets/image/icon_right1.png"),"alt":""}}),_vm._v(" 返回 ")]),_c('delPopup',{ref:"delPopup",on:{"confirm":_vm.confirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }